import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { Toaster, toast } from "sonner";
import { adminLogin } from "../lib/api";

export default function AdminLogin() {
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { token } = await adminLogin(u, p);
      localStorage.setItem("ghh_admin_token", token);
      toast.success("Welcome back!");
      nav("/admin/dashboard");
    } catch {
      toast.error("Invalid credentials");
    } finally { setLoading(false); }
  };

  return (
    <main data-testid="page-admin-login" className="min-h-[80vh] bg-brand-cream flex items-center justify-center px-4 py-16">
      <Toaster position="top-right" richColors />
      <div className="w-full max-w-md bg-white rounded-2xl border border-border p-8 shadow-[0_24px_60px_-30px_rgba(19,60,121,0.3)]">
        <div className="w-12 h-12 rounded-xl bg-brand-navy-deep text-white flex items-center justify-center mb-5"><Lock className="w-6 h-6" /></div>
        <h1 className="font-display text-3xl text-brand-navy-deep">Admin Sign In</h1>
        <p className="text-sm text-slate-600 mt-2">Access appointments and enquiries.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="text-xs font-semibold text-slate-700 mb-1.5 block">Username</label>
            <input data-testid="admin-username" className="w-full bg-white border border-border rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-brand-navy focus:ring-2 focus:ring-brand-navy/15" value={u} onChange={(e)=>setU(e.target.value)} />
          </div>
          <div>
            <label className="text-xs font-semibold text-slate-700 mb-1.5 block">Password</label>
            <input data-testid="admin-password" type="password" className="w-full bg-white border border-border rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-brand-navy focus:ring-2 focus:ring-brand-navy/15" value={p} onChange={(e)=>setP(e.target.value)} />
          </div>
          <button data-testid="admin-login-submit" type="submit" disabled={loading} className="btn-primary w-full justify-center disabled:opacity-60">
            {loading ? <Loader2 className="w-4 h-4 animate-spin"/> : "Sign In"}
          </button>
        </form>
      </div>
    </main>
  );
}
